import React from 'react';

import { ProductTabs } from '../components/ProductTabs';

import { PageShell } from '@/components/page-shell';

/**
 * Ticketing > Drop-offs.
 *
 * Checkouts the guest walked away from after telling us who they are: an
 * email and a phone number were saved, nothing was paid, and the session has
 * expired. A follow-up list for sales, and a list that can be cleaned up -
 * rows are selectable and deletable, except the ones a late payment could
 * still land on.
 */
export const TicketingDropOffsPage = (): React.JSX.Element => (
  <PageShell
    title="Drop-offs"
    description="Guests who entered their details and left before paying. Select rows to delete them; anything a payment could still land on is kept."
  >
    <ProductTabs variant="dropoff" gridIdPrefix="ticketing-dropoffs" />
  </PageShell>
);
